import React from 'react'
import styled from 'styled-components';
import { Imglist } from '../../constants/ImagesList';

export default (props) => {
    let name_team = {
        blue: 'eLigue 1 Uber Eats',
        red: 'LALIGA EA SPORTS',
        yellow: 'Virtual Bundesliga',
        green: 'ePremier League',
    }
    return (
        <RankContent className={"rank rank--" + props.userProfile.team}>
            <div className="rank__left">
                <div className="rank__fake-screen"></div>
                {props.score_team.length > 0 && props.score_team.map((item, key) => {
                    return (
                        <div className={"rank__item rank__item--" + key} key={key}>
                            {item.team===props.userProfile.team
                                ?
                                    <>
                                        <div className={"rank__number active_" + key}>{key+1}</div>
                                        <div className={"rank__label active_"+ key}>
                                            <img src={Imglist['icon_'+props.userProfile.team+'_active']} alt=''/>
                                        </div>
                                    </>
                                :
                                    <>
                                        <div className={"rank__number normal_" + key}>{key+1}</div>
                                        <div className="rank__label">
                                            <img src={Imglist['icon_'+item.team]} alt=''/>
                                            <div className={"rank__point rank__point--" + key}>
                                                <div>คะแนน</div>
                                                <div>{item.score}</div>
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    );
                })}
            </div>
            <div className="rank__right">
                <div className="rank__content">
                    <div className="rank__btn-logout">
                        <img src={Imglist.btn_logout} onClick={()=>props.handleLogout()} alt=''/>
                    </div>
                    <div className="rank__board">
                        <div className="rank__text">
                            สวัสดีคุณ
                            <span> {props.userProfile.manager_name}</span>
                        </div>
                        <div className="rank__text">
                            ทีม
                            <span> {name_team[props.userProfile.team]}</span>
                        </div>
                        <div className="rank__text">
                            คะแนนของคุณ
                            <span> {props.userProfile.points}</span>
                        </div>
                    </div>
                    <img src={Imglist.logo_2} className="rank__logo1" alt=''/>
                    <img src={Imglist['logo_'+props.userProfile.team]} className="rank__logo2" alt=''/>
                    <div className="rank__btn-group">
                        <img src={Imglist.btn_reward} onClick={()=>props.handleReward()} alt=''/>
                        <img src={Imglist.btn_detail} onClick={()=>props.handleDetail()} alt=''/>
                    </div>
                    <div className="rank__inner">
                        <div className={"rank__team-point rank__team-point--" + props.userProfile.team}>
                            <div>คะแนนทีม</div>
                            <div>
                                {props.score_team.length > 0 && props.score_team.map((item, key) => {
                                    if(item.team===props.userProfile.team){
                                        return (
                                            <React.Fragment key={key}>
                                                <div>{item.score}</div>
                                            </React.Fragment>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                        <div className="rank__table">
                            <img src={Imglist['king_' + props.king_of_ranking.team]} className="rank__king" alt=''/>
                            <div className={"rank__head-1 rank__head-1--" + props.userProfile.team + " head1"}>
                                King of Ranking
                            </div>
                            <div className="rank__row-1">
                                <div></div>
                                <div>{props.king_of_ranking.account_name}</div>
                            </div>
                            <div className="rank__row-1 btr">
                                <div></div>
                                <div>
                                    <div>คะแนน</div>
                                    <div>{props.king_of_ranking.point}</div>
                                </div>
                            </div>
                        </div>
                        <div className="rank__table">
                            <div className={"rank__head-1 rank__head-1--" + props.userProfile.team}>
                                อันดับทีม {name_team[props.userProfile.team]}
                            </div>
                            <div className="rank__row-2 head">
                                <div>อันดับ</div>
                                <div>ชื่อผู้จัดการ</div>
                                <div>คะแนน</div>
                            </div>
                            {Object.keys(props.king_of_team).length > 0 && props.king_of_team[props.userProfile.team].map((item, key) => {
                                return (
                                    <div className={"rank__row-2 nothead" + (key===2?' btr':'')} key={key}>
                                        <div>{key+1}.</div>
                                        <div>{item.account_name}</div>
                                        <div>{item.point}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </RankContent>
    );
}

const RankContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    .rank{
        &__left{
            position: relative;
            background: #fff;
            width: 25%;
            height: 111%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            transform: rotate(-11deg);
            padding-left: 2%;
            margin-left: -6%;
            box-sizing: content-box;
        }
        &__fake-screen{
            position: absolute;
            width: 112%;
            left: -12%;
            height: 170%;
            background: #161616;
        }   
        &__item{
            position: relative;
            height: 17%;
            &--0{
                margin-top: 10%;
            }
        }
        &__label{
            position: absolute;
            width: 90%;
            left: 47%;
            top: 50%;
            transform: translate(0,-50%);
            >img{
                width: 100%;
            }
            &.active_0,&.active_1,&.active_2{
                width: 102%;
                left: 6%;
            }
            &.active_3{
                width: 109%;
                left: -1%;
            }
        }
        &__number{
            font-family: 'EASansCurves';
            position: absolute;
            z-index: 2;
            top: 55%;
            transform: translate(0,-50%);
            filter: drop-shadow(0px .5vw .2vw rgba(0,0,0,.5));
            &.normal_0{
                color: #07f468;
                font-size: 8vw;
                left: 35%;
            }
            &.normal_1,&.normal_2,&.normal_3{
                color: #07f468;
                font-size: 8vw;
                left: 34%;
            }
            &.active_0{
                color: #FCFCF7;
                font-size: 10vw;
                left: 34%;
                top: 51%;
            }
            &.active_1{
                color: #FCFCF7;
                font-size: 10vw;
                left: 24%;
            }
            &.active_2{
                color: #FCFCF7;
                font-size: 10vw;
                left: 24%;
                top: 51%;
            }
            &.active_3{
                color: #FCFCF7;
                font-size: 10vw;
                top: 53%;
                left: 20%;
            }
        }
        &__point{
            position: absolute;
            right: 9%;
            width: 57%;
            text-align: center;
            &--0,&--1,&--2{
                top: 45%;
                transform: translate(0,-50%);
            }
            &--3{
                top: 48%;
                transform: translate(0,-50%);
            }
            >div{
                font-family: 'PSLSimilanyaExtraPro';
                color: #000;
                &:first-child{
                    font-size: 1.8vw;
                    line-height: 1;
                }
                &:last-child{
                    font-size: 2vw;
                    line-height: 1;
                }
            }
        }
        &__right{
            width: 31%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        &__content{
            overflow: auto;
            width: 80%;
            // height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            @media(max-width: 850px){
                width: 70%;
            }
        }
        &__btn-logout{
            width: 80%;
            margin: 0 auto 2%;
            >img{
                width: 45%;
                margin-left: auto;
                display: block;
                cursor: pointer;
                &:hover{
                    opacity: .8;
                }
            }
        }
        &__btn-group{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 80%;
            margin: 0 auto;
            >img{
                width: 46%;
                cursor: pointer;
                &:hover{
                    opacity: .8;
                }
            }
        }
        &__logo1{
            @media(max-width: 850px){
                width: 85%;
                margin: 0 auto;
            }
        }
        &__logo2{
            width: 70%;
            margin: 0 auto;
            @media(max-width: 850px){
                width: 55%;
            }
        }
        &__inner{
            width: 100%;
        }
        &__team-point{
            padding-top: 1%;
            margin: 2% 0;
            >div{
                padding: 1% 0;
                &:first-child{
                    color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                    width: 30%;
                    text-align: center;
                    font-size: 1.5vw;
                }
                &:last-child{
                    background: #fff;
                    color: #000;
                    display: inline-block;
                    vertical-align: middle;
                    width: 70%;
                    text-align: center;
                    font-size: 3vw;
                    line-height: 1;
                    border-top-left-radius: 1.5vw;
                    border-bottom-right-radius: 1.5vw;
                }
            }
            &--blue{
                // background: #01d9ee;
                background: rgba(27,172,37,1);
                background: -moz-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(27,172,37,1)), color-stop(47%, rgba(27,172,37,1)), color-stop(100%, rgba(27,172,37,1)));
                background: -webkit-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -o-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -ms-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: linear-gradient(to bottom, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#265bb2', endColorstr='#253dcb', GradientType=0 );
            }
            &--yellow{
                // background: #ffc026;
                background: rgba(251,8,27,1);
                background: -moz-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(251,8,27,1)), color-stop(53%, rgba(251,8,27,1)), color-stop(100%, rgba(251,8,27,1)));
                background: -webkit-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -o-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -ms-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: linear-gradient(to bottom, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffae23', endColorstr='#fccb18', GradientType=0 );
            }
            &--red{
                // background: #ff797a;
                background: rgba(246,190,0,1);
                background: -moz-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(246,190,0,1)), color-stop(47%, rgba(246,190,0,1)), color-stop(100%, rgba(246,190,0,1)));
                background: -webkit-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -o-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -ms-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: linear-gradient(to bottom, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fc67b1', endColorstr='#fd6bb4', GradientType=0 );
            }
            &--green{
                // background: #CDFBOA;
                background: rgba(254, 41, 131);
                background: -moz-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(254, 41, 131)), color-stop(47%, rgba(254, 41, 131)), color-stop(100%, rgba(254, 41, 131)));
                background: -webkit-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -o-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -ms-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: linear-gradient(to bottom, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#CDFBOA', endColorstr='#208d11', GradientType=0 );
            }
        }
        &__table{
            width: 100%;
            margin: 2% 0;
            position: relative;
        }
        &__head-1{
            background: #ffc026;
            font-size: 2vw;
            color: #fff;
            text-align: center;
            border-top-left-radius: 1.5vw;
            &.head1{
                border-bottom: .2vw solid #d3b9c6;
            }
            &--blue{
                // background: #01d9ee;
                background: rgba(27,172,37,1);
                background: -moz-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(27,172,37,1)), color-stop(47%, rgba(27,172,37,1)), color-stop(100%, rgba(27,172,37,1)));
                background: -webkit-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -o-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: -ms-linear-gradient(top, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                background: linear-gradient(to bottom, rgba(27,172,37,1) 0%, rgba(27,172,37,1) 47%, rgba(27,172,37,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#265bb2', endColorstr='#253dcb', GradientType=0 );
            }
            &--yellow{
                // background: #ffc026;
                background: rgba(251,8,27,1);
                background: -moz-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(251,8,27,1)), color-stop(53%, rgba(251,8,27,1)), color-stop(100%, rgba(251,8,27,1)));
                background: -webkit-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -o-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: -ms-linear-gradient(top, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                background: linear-gradient(to bottom, rgba(251,8,27,1) 0%, rgba(251,8,27,1) 53%, rgba(251,8,27,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffae23', endColorstr='#fccb18', GradientType=0 );
            }
            &--red{
                // background: #ff797a;
                background: rgba(246,190,0,1);
                background: -moz-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(246,190,0,1)), color-stop(47%, rgba(246,190,0,1)), color-stop(100%, rgba(246,190,0,1)));
                background: -webkit-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -o-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: -ms-linear-gradient(top, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                background: linear-gradient(to bottom, rgba(246,190,0,1) 0%, rgba(246,190,0,1) 47%, rgba(246,190,0,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fc67b1', endColorstr='#fd6bb4', GradientType=0 );
            }
            &--green{
                // background: #CDFBOA;
                background: rgba(254, 41, 131);
                background: -moz-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(254, 41, 131)), color-stop(47%, rgba(254, 41, 131)), color-stop(100%, rgba(254, 41, 131)));
                background: -webkit-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -o-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: -ms-linear-gradient(top, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                background: linear-gradient(to bottom, rgba(254, 41, 131) 0%, rgba(254, 41, 131) 47%, rgba(254, 41, 131) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#CDFBOA', endColorstr='#208d11', GradientType=0 );
            }
        }
        &__row-1{
            font-size: 1.5vw;
            color: #000;
            background: rgba(243,211,230,.8);
            border-bottom: .2vw solid #d3b9c6;
            border-left: .2vw solid #d3b9c6;
            border-right: .2vw solid #d3b9c6;
            >div{
                &:first-child{
                    width: 20%;
                    display: inline-block;
                    vertical-align: middle;
                }
                &:last-child{
                    width: 80%;
                    display: inline-block;
                    vertical-align: middle;
                    text-align: center;
                    >div{
                        &:first-child{
                            width: 50%;
                            display: inline-block;
                            vertical-align: middle;
                        }
                        &:last-child{
                            width: 50%;
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }
            }
            &.btr{
                border-bottom-right-radius: 1.5vw;
            }
        }
        &__row-2{
            font-size: 1.5vw;
            color: #000;
            background: rgba(243,211,230,.8);
            display: flex;
                align-items: center;
            >div{
                &:nth-child(1){
                    width: 15%;
                    text-align: center;
                }
                &:nth-child(2){
                    width: 65%;
                    text-align: center;
                    border-left: .2vw solid #d3b9c6;
                    border-right: .2vw solid #d3b9c6;
                }
                &:nth-child(3){
                    width: 20%;
                    text-align: center;
                }
            }
            &.btr{
                border-bottom-right-radius: 1.5vw;
            }
            &.head{
                font-size: 1.6vw;
                border: .2vw solid #d3b9c6;
            }
            &.nothead{
                border-bottom: .2vw solid #d3b9c6;
                border-left: .2vw solid #d3b9c6;
                border-right: .2vw solid #d3b9c6;
            }
        }
        &__board{
            width: 80%;
            margin: 0 auto;
            border: 0.1vw solid rgb(255 255 255);
            padding: 2% 10%;
            background: rgba(0,0,0,.5);
        }
        &__text{
            color: #fff;
            font-size: 1.5vw;
            line-height: 1;
            >span{
                color: #07f468;
            }
        }
        &__king{
            position: absolute;
            width: 15%;
            top: 70%;
            left: 10%;
            transform: translate(0,-50%);
        }
    }
`;